module.exports = __webpack_public_path__ + "img/icon-gym.06de7d87.svg";